import { FC } from 'react';

/** @deprecated */
const DisclosuresIcon: FC = () => (
  <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5314 2.5H18.5314V23.5H0.531372V2.5H2.53137"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5314 2.5C11.5314 1.396 10.6374 0.5 9.53137 0.5C8.42737 0.5 7.53137 1.396 7.53137 2.5H4.53137V5.5H14.5314V2.5H11.5314V2.5Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.53137 4.5H2.53137V21.5H12.5314V17.5H16.5314V4.5H14.5314"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5314 17.5L12.5314 21.5"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.53137 11L6.32437 10.207C6.71437 9.816 7.34837 9.816 7.73837 10.207L7.82437 10.293C8.21437 10.684 8.84837 10.684 9.23837 10.293L9.32437 10.207C9.71437 9.816 10.3484 9.816 10.7384 10.207L10.8244 10.293C11.2144 10.684 11.8484 10.684 12.2384 10.293L13.0314 9.5"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.53137 15L6.32437 14.207C6.71437 13.816 7.34837 13.816 7.73837 14.207L7.82437 14.293C8.21437 14.684 8.84837 14.684 9.23837 14.293L9.32437 14.207C9.71437 13.816 10.3484 13.816 10.7384 14.207L10.8244 14.293C11.2144 14.684 11.8484 14.684 12.2384 14.293L13.0314 13.5"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DisclosuresIcon;
